import { ShieldOff } from 'lucide-react';
import { motion } from 'framer-motion';

export function UnauthorizedAccess() {
  return (
    <div className="h-full w-full flex items-center justify-center p-4">
      {/* Dotted Border Container */}
      <div className="w-full h-full rounded-lg border-2 border-dashed border-border bg-muted/30 flex items-center justify-center">
        {/* Content */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, ease: [0.4, 0, 0.2, 1] }}
          className="flex flex-col items-center text-center space-y-3 max-w-md px-6"
        >
          {/* Icon */}
          <div className="relative">
            <div className="absolute -inset-1 rounded-full bg-gradient-to-r from-amber-500/20 via-amber-500/30 to-amber-500/20 blur-md" />
            <div className="relative h-14 w-14 rounded-full bg-gradient-to-br from-amber-500/10 via-background to-amber-500/10 flex items-center justify-center ring-1 ring-amber-500/20">
              <ShieldOff className="h-7 w-7 text-amber-500" />
            </div>
          </div>

          {/* Text */}
          <div className="space-y-1.5">
            <h3 className="text-xl font-semibold tracking-tight">
              Access Restricted
            </h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              You don't have permission to access this section. Contact your administrator to request access.
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
